import { useSelector } from 'react-redux';
import useDelayedOpening from 'src/new_arch/hooks/useDelayedOpening';
import useCreateProject from './useCreateProject';

type UseCreateProjectModalParams = {
	onProjectCreationFailed?: () => void,
	onProjectCreationSuccess?: ( projectID: number ) => void
};

const useCreateProjectModal = ( {
	onProjectCreationFailed,
	onProjectCreationSuccess
}: UseCreateProjectModalParams ) => {
	const opened = useDelayedOpening();
	const createProject = useCreateProject( {
		onProjectCreationFailed,
		onProjectCreationSuccess
	} );

	const createProjectRequest = useSelector(
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		state => state.createProjectRequest
	);

	return {
		opened,
		isCreatingProject: createProjectRequest.sending,
		onFormSubmitted: createProject
	};
};

export default useCreateProjectModal;
